<template>
    <c-modal @close="close" :title="'Dienst'">
        <c-form ref="form" @valid="submit" :autocomplete="'off'">
            <c-form-element
                :label="'Aanvraag namens'"
                :horizontal="true"
                v-if="user.is_planner"
                :clean="true"
            >
                <c-select
                    :options="aanvragers"
                    :required="true"
                    :searchable="true"
                    v-model="aanvrager"
                />
            </c-form-element>

            <c-form-element
                :label="'Dienst'"
                :horizontal="true">
                <c-radio
                    v-model="is_tolk_opdracht"
                    :options="getDiensten()"></c-radio>
            </c-form-element>

            <c-interpreter-request
                ref="modalform"
                :initial-date="initialDate"
                :edit="edit"
                v-if="is_tolk_opdracht==1">
            </c-interpreter-request>
            <c-translation-request
                ref="modalform"
                :edit="edit"
                v-if="is_tolk_opdracht==0">
            </c-translation-request>

            <c-form-element
                v-if="aanvrager"
                :label="'Alternatief e-mailadres'"
                :horizontal="true"
            >
                <input type="email" v-model="email" :name="'email'" :placeholder="default_email"/>
            </c-form-element>

            <div class="c-modal__btn">
                <input type="submit" class="c-btn c-btn--secondary no-margin" :value="edit ? 'Aanvraag aanpassen' : 'Aanvraag indienen'"/>
            </div>
        </c-form>
    </c-modal>
</template>

<script>
import CModal from '@components/Modal';

import CTranslationRequest from '@app/modals/TranslationRequest';
import CInterpreterRequest from '@app/modals/InterpreterRequest';

import Form from '@mixins/Form';
import { mapState } from 'vuex';

export default {
    components: {
        CModal,
        CTranslationRequest,
        CInterpreterRequest
    },
    props: {
        edit: {
            required: false
        },
        data: {
            type: Object,
            required: false,
            default: ()=>{}
        }
    },
    mixins: [ Form ],
    data() {
        return {
            is_tolk_opdracht: null,
            aanvrager: null,
            email: null,
            default_email: null,
            initialDate: undefined
        }
    },
    watch: {
        is_tolk_opdracht() {
            this.$nextTick( () => {
                this.$refs.form.reinitialize();
            });
        },
        aanvrager(val) {
            const av = this.clients.find(aanvrager => aanvrager.id == val.code);
            this.default_email = av?.organisatie?.contract?.centraal_notificatie_emailadres ?? av?.user?.email;
        },
        clients(clients) {
            const av = this.clients.find(aanvrager => aanvrager.id == this.aanvrager?.code);
            this.default_email = av?.organisatie?.contract?.centraal_notificatie_emailadres ?? av?.user?.email;
        },
        data(value){
            if (typeof value !== 'undefined') {
                let date = new Date()
                date.setFullYear(value.year)
                date.setDate(value.day)
                date.setMonth(value.month - 1)
                this.initialDate = date.toISOString().slice(0, 10);
            }
        }
    },
    methods: {
        getDiensten() {
            let options = [];
            if (this.user.is_planner || this.user?.opdrachtgever?.organisatie?.contract?.is_voor_tolken) {
                options.push({label:'Tolkdienst', value: 1});
            }
            if (this.user.is_planner || this.user?.opdrachtgever?.organisatie?.contract?.is_voor_vertalen) {
                options.push({label:'Vertaaldienst', value: 0});
            }
            return options;
        },
        close() {
            if ( this.edit == undefined ){
                this.is_tolk_opdracht = null;
            }

            this.$emit('close');
        },
        submit() {

            let data = this.$refs.modalform._data;
            let postfix = '';

            data.is_tolk_opdracht = this.is_tolk_opdracht;
            data.opdrachtgever_id = this.aanvrager.code;
            data.email = this.email;

            if ( this.edit ) {
                data.opdracht = this.edit.id;
                postfix = 'edit/'
            }

            this.$xhr.post('/api/requests/' + postfix, data).then( ({result}) => {

                if ( this.edit ) {

                    this.$emit('update');
                    this.close();
                    this.$store.dispatch('toasts/success', {title: 'Aanvraag aanpassen', text: 'Je aanvraag is aangepast'});
                }
                else {
                    this.$router.push({name: 'request-detail', params: { id: result.id }});
                    this.$store.dispatch('toasts/success', {title: 'Aanvraag inschieten', text: 'Je aanvraag staat klaar voor de planning'});
                }


            }).catch( (e) => {
                if ( this.edit ) {
                    this.$store.dispatch('toasts/alert', {title: 'Aanvraag aanpassen', text: 'Er is helaas iets fout gegaan bij het aanpassen van de aanvraag'});
                }
                else {
                    this.$store.dispatch('toasts/alert', {title: 'Aanvraag inschieten', text: 'Er is helaas iets fout gegaan bij het inschieten van de aanvraag'});
                }
            });
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.data,
            aanvragers: state => state.preferences.data.clients
                .filter(item => item.is_aanvrager == 1)
                .filter(item => item?.organisatie?.contract?.is_voor_vertalen || item?.organisatie?.contract?.is_voor_tolken)
                .reduce((formatted, item) => { formatted[item.id] = item.user.name; return formatted; }, {}),
            clients: state => state.preferences.data.clients,
        }),
    },
    mounted() {

        if ( this.edit ) {

            this.is_tolk_opdracht = this.edit.is_tolk_opdracht ? 1 : 0;
            this.aanvrager = {code: this.edit.opdrachtgever.id, label: this.edit.opdrachtgever.user.name };
            this.email = this.edit.email;

            this.$nextTick( () => {

                let data = this.$refs.modalform._data;

                Object.keys(data).forEach( (key) => {

                    let defaultvalue = false;

                    switch (key) {

                        case 'datum':
                            this.$refs.modalform[key] = this.$options.filters.datestring(this.edit.begintijd);
                            break;

                        case 'deadline':
                            this.$refs.modalform[key] = this.$options.filters.datestring(this.edit.deadline);
                            break;

                        case 'deadline_tijd':
                            this.$refs.modalform[key] = this.$options.filters.time(this.edit.deadline);
                            break;

                        case 'eindtijd':
                            this.$refs.modalform[key] = this.$options.filters.time(this.edit.eindtijd);
                            break;

                        case 'starttijd':
                            this.$refs.modalform[key] = this.$options.filters.time(this.edit.begintijd);
                            break;

                        case 'brontaal':
                            if ( this.edit.vertalingen && this.edit.vertalingen.length > 0 ) {
                                this.$refs.modalform[key] = { 'code': this.edit.vertalingen[0].brontaal_id + '', 'label': this.edit.vertalingen[0].brontaal.taal };
                            }
                            break;

                        case 'doeltaal':

                            if ( this.edit.vertalingen && this.edit.vertalingen.length > 0 ) {

                                this.$refs.modalform[key] = [];

                                this.edit.vertalingen.forEach( (v) => {
                                    if (!v.deleted_at) {
                                        this.$refs.modalform[key].push({ 'code': v.doeltaal_id + '', 'label': v.doeltaal.taal });
                                    }
                                });
                            }
                            break;

                        case 'specialisatie':

                            if ( this.edit.specialisaties && this.edit.specialisaties.length ) {
                                this.$refs.modalform[key] = this.edit.specialisaties[0].id;
                            }

                            break;

                        default:
                            defaultvalue = true;
                            break;
                    }
                    if ( defaultvalue ){
                        if ( this.edit[key] ) {
                            this.$refs.modalform[key] = this.edit[key];
                        }
                        else if ( this.edit.adres && this.edit.adres[key] ) {
                            this.$refs.modalform[key] = this.edit.adres[key];
                        }
                    }
                });

                this.$refs.modalform.$forceUpdate();
            });
        } else {
            if (!this.user.is_planner) {
                this.aanvrager = { code: this.user.opdrachtgever_id, label: this.user.name };
            }
        }
    }
}
</script>
